import type { AstSignMailSwitchboardTransferRequest } from 'features/ast-signmail/interfaces';
import { AstSignMailDaoService } from 'features/ast-signmail/services';
import { AST_SIGNMAIL_TRANSFER_TIMEOUT_MS } from 'features/ast-signmail/constants';
import { CallDaoService } from 'features/call/call-base/services';

export const transferCallOwnershipToAST = async (callId: number) => {
  const transferAstRelayResponse =
    await CallDaoService.transferASTRelay(callId);
  return transferAstRelayResponse;
};

export const transferCallToAST = async (
  transferRequest: AstSignMailSwitchboardTransferRequest
) => {
  let timeoutId: ReturnType<typeof globalThis.setTimeout> | undefined;
  const timeoutPromise = new Promise<never>((_, reject) => {
    timeoutId = globalThis.setTimeout(() => {
      reject(
        new Error(
          `AST SignMail transfer timed out after ${AST_SIGNMAIL_TRANSFER_TIMEOUT_MS}ms`
        )
      );
    }, AST_SIGNMAIL_TRANSFER_TIMEOUT_MS);
  });

  try {
    return await Promise.race([
      AstSignMailDaoService.transferToAst(transferRequest),
      timeoutPromise,
    ]);
  } finally {
    if (timeoutId !== undefined) {
      globalThis.clearTimeout(timeoutId);
    }
  }
};
